import React, { useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
// import { debounce } from "../../utils/throttleDebounce";
import "./FixedBtn.scss";

export const FixedBtn = ({ bottom, bg, tooltip, icon, onClick, toTopBtn }) => {
  const [visible, setVisible] = useState(false);
  function debounce() {}
  const makeVisible = debounce(() => {
    return !visible ? setVisible(true) : window.pageYOffset === 0 ? setVisible(false) : null;
  }, 100);

  useEffect(() => {
    if (toTopBtn) {
      window.addEventListener("scroll", makeVisible);

      return () => window.removeEventListener("scroll", makeVisible);
    }
  }, [window.pageYOffset]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={`fixed-btn${!toTopBtn || visible ? " visible" : ""}`} onClick={onClick} style={bottom}>
      <Tooltip title={tooltip} placement="left">
        <div className="fixed-btn__circle" style={bg}>
          {icon}
        </div>
      </Tooltip>
    </div>
  );
};
